import { render, staticRenderFns } from "./AppsLayout.vue?vue&type=template&id=44afdb8c&"
import script from "./AppsLayout.vue?vue&type=script&lang=ts&"
export * from "./AppsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports